import React from "react";

const Staff = () => {
  const staffData = [
    {
      role: "Legal Advisor",
      icon: "fa-gavel",
      desc: "Ensures all recruitment processes comply with international labor laws and embassy regulations.",
    },
    {
      role: "General Manager",
      icon: "fa-user-tie",
      desc: "Oversees daily operations and maintains high-level coordination with overseas clients.",
    },
    {
      role: "HR Manager",
      icon: "fa-users-cog",
      desc: "Expert in talent acquisition, technical vetting, and managing candidate relations.",
    },
    {
      role: "Protector Representative",
      icon: "fa-shield-alt",
      desc: "Handles all government clearances and Bureau of Emigration formalities for smooth deployment.",
    },
  ];

  return (
    <div className=" bg-light">
      <div className="container-xxl py-5 bg-light">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-light text-center text-primary px-3">
              Our Team
            </h6>
            <h1 className="mb-5">Management Staff</h1>
          </div>

          <div className="row g-5">
            {staffData.map((staff, index) => (
              <div
                className="col-lg-3 col-md-6 wow fadeInUp"
                key={index}
                data-wow-delay={`${index * 0.1}s`}
              >
                <div
                  className="position-relative bg-white shadow-sm border-0 h-100 p-4 pt-5"
                  style={{
                    borderRadius: "20px",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  {/* Floating Icon Holder */}
                  <div
                    className="position-absolute top-0 start-50 translate-middle shadow-sm d-flex align-items-center justify-content-center bg-primary"
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "15px",
                      transform: "translate(-50%, -50%) rotate(-10deg)",
                    }}
                  >
                    <i
                      className={`fa ${staff.icon} text-white fa-2x`}
                      style={{ transform: "rotate(10deg)" }}
                    ></i>
                  </div>

                  <div className="text-center mt-3">
                    <h5 className="fw-bold text-dark mb-3">{staff.role}</h5>
                    <div
                      className="mx-auto mb-3 bg-primary"
                      style={{
                        width: "30px",
                        height: "3px",
                        borderRadius: "2px",
                      }}
                    ></div>
                    <p
                      className="text-muted small mb-0 px-2"
                      style={{ lineHeight: "1.6" }}
                    >
                      {staff.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Staff;
